import { type PropsWithClassName } from "@/components/podkit/lib/cn";
import { useId, useRef, type FC } from "react";

export const GoLandLogo: FC<PropsWithClassName> = ({ className }) => {
    const id = useRef(useId()).current;

    return (
        <svg
            className={className}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M21.1163 9.28955L23.9688 15.6156L19.0865 23.9688L16.0794 16.6678L21.1163 9.28955Z"
                fill={`url(#paint0_linear_${id})`}
            />
            <path d="M16.0794 16.6678L19.0865 23.9688L11.5212 21.3681L16.0794 16.6678Z" fill="#B74AF7" />
            <path
                d="M16.8947 6.79102L15.3438 0.0311279H6.74369L0.0311661 10.2994L1.97361 15.0171L0.0311661 19.3234L13.9325 7.49669L16.8947 6.79102Z"
                fill={`url(#paint1_linear_${id})`}
            />
            <path
                d="M23.9688 5.11292L13.9325 7.49671L0.0311661 19.3234L8.99782 23.9688L16.0794 16.6678L23.9688 5.11292Z"
                fill={`url(#paint2_linear_${id})`}
            />
            <path d="M4.51948 4.51953H19.4805V19.4806H4.51948V4.51953Z" fill="black" />
            <path d="M5.92332 16.6753H11.5337V17.6104H5.92332V16.6753Z" fill="white" />
            <path
                d="M5.50193 9.58378V9.56633C5.5005 9.1439 5.5836 8.72545 5.74635 8.33563C5.90909 7.9458 6.14818 7.59248 6.44955 7.29646C6.75091 7.00044 7.10846 6.76771 7.50113 6.61196C7.8938 6.45622 8.31367 6.38062 8.736 6.3896C9.62422 6.34279 10.4954 6.6463 11.1622 7.2349L10.3069 8.26721C9.87329 7.85255 9.2935 7.62583 8.69361 7.63635C7.69621 7.63635 6.92073 8.50908 6.92073 9.55635V9.57381C6.92073 10.7034 7.69621 11.5312 8.79086 11.5312C9.24488 11.5446 9.69157 11.4146 10.0675 11.1597V10.272H8.70109V9.10004H11.3766V11.7781C10.6453 12.4124 9.70907 12.7605 8.74099 12.758C6.82348 12.758 5.50193 11.409 5.50193 9.58378Z"
                fill="white"
            />
            <path
                d="M11.9501 9.5838V9.56635C11.9516 9.14006 12.0385 8.71839 12.2057 8.32627C12.3729 7.93414 12.6171 7.57952 12.9237 7.28336C13.2303 6.98721 13.5932 6.75553 13.9909 6.60202C14.3886 6.44851 14.813 6.37629 15.2391 6.38962C17.1416 6.38962 18.5081 7.80843 18.5081 9.56136V9.57882C18.5086 10.0061 18.4232 10.4292 18.2571 10.8229C18.0909 11.2166 17.8473 11.5729 17.5407 11.8706C17.2342 12.1684 16.8709 12.4014 16.4725 12.556C16.0741 12.7106 15.6487 12.7835 15.2216 12.7705C13.3166 12.758 11.9501 11.3392 11.9501 9.5838ZM17.0893 9.5838V9.56635C17.0969 9.31607 17.0543 9.06679 16.964 8.83326C16.8736 8.59974 16.7373 8.3867 16.5632 8.20676C16.3891 8.02682 16.1806 7.88363 15.9502 7.78566C15.7198 7.68769 15.472 7.63692 15.2216 7.63638C14.9731 7.63554 14.727 7.68491 14.498 7.78152C14.2691 7.87813 14.062 8.02 13.8892 8.1986C13.7164 8.37721 13.5815 8.58888 13.4925 8.82091C13.4036 9.05294 13.3624 9.30055 13.3714 9.54889V9.56635C13.3627 9.81758 13.4047 10.068 13.4947 10.3027C13.5847 10.5374 13.721 10.7516 13.8955 10.9326C14.0699 11.1136 14.279 11.2576 14.5102 11.3562C14.7415 11.4547 14.9902 11.5058 15.2416 11.5063C15.4907 11.5069 15.7374 11.4569 15.9668 11.3596C16.1961 11.2622 16.4034 11.1194 16.5761 10.9397C16.7487 10.7601 16.8832 10.5473 16.9714 10.3143C17.0596 10.0812 17.0997 9.83275 17.0893 9.5838Z"
                fill="white"
            />
            <defs>
                <linearGradient
                    id={`paint0_linear_${id}`}
                    x1="23.6023"
                    y1="13.6657"
                    x2="14.2541"
                    y2="21.5776"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#087CFA" />
                    <stop offset="0.02" stopColor="#0D7BFA" />
                    <stop offset="0.37" stopColor="#5566F9" />
                    <stop offset="0.66" stopColor="#8A57F8" />
                    <stop offset="0.88" stopColor="#AB4EF7" />
                    <stop offset="1" stopColor="#B74AF7" />
                </linearGradient>
                <linearGradient
                    id={`paint1_linear_${id}`}
                    x1="8.26971"
                    y1="7.4518"
                    x2="13.9524"
                    y2="0.986141"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#087CFA" />
                    <stop offset="0.02" stopColor="#0D7BFA" />
                    <stop offset="0.37" stopColor="#5566F9" />
                    <stop offset="0.66" stopColor="#8A57F8" />
                    <stop offset="0.88" stopColor="#AB4EF7" />
                    <stop offset="1" stopColor="#B74AF7" />
                </linearGradient>
                <linearGradient
                    id={`paint2_linear_${id}`}
                    x1="3.3575"
                    y1="20.9417"
                    x2="20.625"
                    y2="9.84559"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#087CFA" />
                    <stop offset="0.1" stopColor="#1598D3" />
                    <stop offset="0.22" stopColor="#23B6AA" />
                    <stop offset="0.35" stopColor="#2DCC8B" />
                    <stop offset="0.46" stopColor="#35DD74" />
                    <stop offset="0.57" stopColor="#39E767" />
                    <stop offset="0.67" stopColor="#3BEA62" />
                </linearGradient>
            </defs>
        </svg>
    );
};
